import { useLang } from '../../../hooks/useLang';

const FOOTER_LABELS: Record<string, Record<string, string>> = {
  contactTitle: { zh: '联系我们', en: 'Contact Us', fr: 'Contactez-nous', es: 'Contáctenos', pt: 'Contate-nos', ja: 'お問い合わせ', de: 'Kontakt', ko: '문의하기', ar: 'اتصل بنا', ru: 'Связаться с нами' },
  contactDesc: { zh: '如您对RWA合规、代币化资产、香港持牌通道或企业落地方案有任何疑问，欢迎通过以下方式联系我们进行专业交流。本平台仅提供知识科普，不提供投资建议。', en: 'If you have any questions about RWA compliance, tokenized assets, HK licensed channels, or enterprise solutions, please contact us. This platform provides educational content only, not investment advice.', fr: 'Si vous avez des questions sur la conformité RWA, les actifs tokenisés, les canaux agréés HK ou les solutions d\'entreprise, contactez-nous. Cette plateforme fournit uniquement du contenu éducatif.', es: 'Si tiene preguntas sobre cumplimiento RWA, activos tokenizados, canales con licencia HK o soluciones empresariales, contáctenos. Esta plataforma proporciona solo contenido educativo.', pt: 'Se tiver dúvidas sobre conformidade RWA, ativos tokenizados, canais licenciados HK ou soluções empresariais, entre em contato. Esta plataforma fornece apenas conteúdo educacional.', ja: 'RWAコンプライアンス、トークン化資産、HK認可チャネル、または企業ソリューションについてご質問がある場合は、お問い合わせください。このプラットフォームは教育コンテンツのみを提供します。', de: 'Bei Fragen zu RWA-Compliance, tokenisierten Vermögenswerten, HK-lizenzierten Kanälen oder Unternehmenslösungen kontaktieren Sie uns. Diese Plattform bietet nur Bildungsinhalte.', ko: 'RWA 컴플라이언스, 토큰화 자산, HK 인가 채널 또는 기업 솔루션에 대한 질문이 있으시면 문의하세요. 이 플랫폼은 교육 콘텐츠만 제공합니다.', ar: 'إذا كان لديك أسئلة حول امتثال RWA أو الأصول المرمزة أو القنوات المرخصة في HK أو حلول المؤسسات، فاتصل بنا. تقدم هذه المنصة محتوى تعليمياً فقط.', ru: 'Если у вас есть вопросы о соответствии RWA, токенизированных активах, лицензированных каналах HK или корпоративных решениях, свяжитесь с нами. Платформа предоставляет только образовательный контент.' },
  wechatScan: { zh: '微信扫码交流', en: 'WeChat QR Code', fr: 'QR Code WeChat', es: 'Código QR WeChat', pt: 'QR Code WeChat', ja: 'WeChat QRコード', de: 'WeChat QR-Code', ko: 'WeChat QR 코드', ar: 'رمز QR WeChat', ru: 'QR-код WeChat' },
  phone: { zh: '电话', en: 'Phone', fr: 'Téléphone', es: 'Teléfono', pt: 'Telefone', ja: '電話', de: 'Telefon', ko: '전화', ar: 'هاتف', ru: 'Телефон' },
  email: { zh: '邮箱', en: 'Email', fr: 'E-mail', es: 'Correo', pt: 'E-mail', ja: 'メール', de: 'E-Mail', ko: '이메일', ar: 'بريد إلكتروني', ru: 'Эл. почта' },
  wechat: { zh: '微信', en: 'WeChat', fr: 'WeChat', es: 'WeChat', pt: 'WeChat', ja: 'WeChat', de: 'WeChat', ko: 'WeChat', ar: 'WeChat', ru: 'WeChat' },
  wechatAdd: { zh: '扫描左侧二维码添加微信', en: 'Scan QR code to add WeChat', fr: 'Scannez le QR code pour ajouter WeChat', es: 'Escanee el código QR para agregar WeChat', pt: 'Escaneie o QR code para adicionar WeChat', ja: 'QRコードをスキャンしてWeChatを追加', de: 'QR-Code scannen um WeChat hinzuzufügen', ko: 'QR 코드를 스캔하여 WeChat 추가', ar: 'امسح رمز QR لإضافة WeChat', ru: 'Сканируйте QR-код для добавления WeChat' },
  forumTitle: { zh: 'RWA 论坛', en: 'RWA Forum', fr: 'Forum RWA', es: 'Foro RWA', pt: 'Fórum RWA', ja: 'RWAフォーラム', de: 'RWA-Forum', ko: 'RWA 포럼', ar: 'منتدى RWA', ru: 'Форум RWA' },
  forumDesc: { zh: '注册后参与讨论', en: 'Register to join', fr: "S'inscrire pour participer", es: 'Regístrese para participar', pt: 'Registre-se para participar', ja: '登録して参加', de: 'Registrieren zum Mitmachen', ko: '등록 후 참여', ar: 'سجل للمشاركة', ru: 'Зарегистрируйтесь' },
  forumEnter: { zh: '进入论坛 →', en: 'Enter Forum →', fr: 'Entrer →', es: 'Entrar →', pt: 'Entrar →', ja: 'フォーラムへ →', de: 'Forum betreten →', ko: '포럼 입장 →', ar: 'دخول المنتدى ←', ru: 'Войти в форум →' },
  officialLinks: { zh: '官方权威链接', en: 'Official Authority Links', fr: 'Liens Officiels', es: 'Enlaces Oficiales', pt: 'Links Oficiais', ja: '公式権威リンク', de: 'Offizielle Links', ko: '공식 권위 링크', ar: 'روابط رسمية', ru: 'Официальные Ссылки' },
  officialDesc: { zh: '所有链接均为真实官方地址，点击可直达', en: 'All links are verified official addresses', fr: 'Tous les liens sont des adresses officielles vérifiées', es: 'Todos los enlaces son direcciones oficiales verificadas', pt: 'Todos os links são endereços oficiais verificados', ja: 'すべてのリンクは公式アドレスです', de: 'Alle Links sind verifizierte offizielle Adressen', ko: '모든 링크는 공식 주소입니다', ar: 'جميع الروابط عناوين رسمية موثقة', ru: 'Все ссылки — проверенные официальные адреса' },
  coreContent: { zh: '核心内容', en: 'Core Content', fr: 'Contenu Principal', es: 'Contenido Principal', pt: 'Conteúdo Principal', ja: 'コアコンテンツ', de: 'Kerninhalt', ko: '핵심 콘텐츠', ar: 'المحتوى الأساسي', ru: 'Основной Контент' },
  moreResources: { zh: '更多资源', en: 'More Resources', fr: 'Plus de Ressources', es: 'Más Recursos', pt: 'Mais Recursos', ja: 'その他のリソース', de: 'Weitere Ressourcen', ko: '더 많은 리소스', ar: 'موارد أخرى', ru: 'Больше Ресурсов' },
  brandDesc: { zh: '中文最全面的RWA知识平台。整合全球政策、87个案例、香港持牌通道、企业SOP，帮助你合规理解并参与真实世界资产代币化浪潮。', en: "The most comprehensive RWA knowledge platform. Integrating global policies, 87 cases, HK licensed channels, and enterprise SOPs to help you compliantly understand and participate in real-world asset tokenization.", fr: "La plateforme de connaissances RWA la plus complète. Intégrant politiques mondiales, 87 cas, canaux agréés HK et SOP d'entreprise.", es: 'La plataforma de conocimiento RWA más completa. Integrando políticas globales, 87 casos, canales con licencia HK y SOP empresariales.', pt: 'A plataforma de conhecimento RWA mais abrangente. Integrando políticas globais, 87 casos, canais licenciados HK e SOPs empresariais.', ja: '最も包括的なRWA知識プラットフォーム。グローバルポリシー、87事例、HK認可チャネル、企業SOPを統合。', de: 'Die umfassendste RWA-Wissensplattform. Integration globaler Richtlinien, 87 Fälle, HK-lizenzierte Kanäle und Unternehmens-SOPs.', ko: '가장 포괄적인 RWA 지식 플랫폼. 글로벌 정책, 87개 사례, HK 인가 채널, 기업 SOP 통합.', ar: 'منصة معرفة RWA الأكثر شمولاً. تدمج السياسات العالمية و87 حالة وقنوات HK المرخصة وإجراءات المؤسسات.', ru: 'Наиболее полная платформа знаний RWA. Интеграция глобальных политик, 87 случаев, лицензированных каналов HK и корпоративных SOP.' },
  disclaimer: { zh: '本站仅供科普，不募资、不推介、不交易', en: 'Educational only — no fundraising, solicitation, or trading', fr: 'Éducatif uniquement — pas de collecte de fonds, sollicitation ou trading', es: 'Solo educativo — sin recaudación de fondos, solicitud o trading', pt: 'Apenas educacional — sem captação de recursos, solicitação ou negociação', ja: '教育目的のみ — 資金調達・勧誘・取引なし', de: 'Nur Bildung — keine Mittelbeschaffung, Werbung oder Handel', ko: '교육 목적만 — 자금 모집, 권유, 거래 없음', ar: 'تعليمي فقط — لا جمع أموال ولا ترويج ولا تداول', ru: 'Только образование — без сбора средств, рекламы или торговли' },
  bottomBar: { zh: '© 2026 RWA99.cn ｜ 仅供知识科普，不构成投资建议 ｜ 严格遵守中国内地及香港法规', en: '© 2026 RWA99.cn | For educational purposes only, not investment advice | Compliant with applicable regulations', fr: '© 2026 RWA99.cn | À des fins éducatives uniquement, pas de conseil en investissement | Conforme aux réglementations applicables', es: '© 2026 RWA99.cn | Solo con fines educativos, no es asesoramiento de inversión | Cumple con las regulaciones aplicables', pt: '© 2026 RWA99.cn | Apenas para fins educacionais, não é aconselhamento de investimento | Em conformidade com os regulamentos aplicáveis', ja: '© 2026 RWA99.cn | 教育目的のみ、投資アドバイスではありません | 適用規制に準拠', de: '© 2026 RWA99.cn | Nur zu Bildungszwecken, keine Anlageberatung | Konform mit geltenden Vorschriften', ko: '© 2026 RWA99.cn | 교육 목적만, 투자 조언 아님 | 관련 규정 준수', ar: '© 2026 RWA99.cn | لأغراض تعليمية فقط، ليس نصيحة استثمارية | متوافق مع اللوائح المعمول بها', ru: '© 2026 RWA99.cn | Только в образовательных целях, не является инвестиционным советом | Соответствует применимым нормам' },
};

function getL(key: string, lang: string): string {
  return FOOTER_LABELS[key]?.[lang] ?? FOOTER_LABELS[key]?.['en'] ?? key;
}

const QUICK_LINKS: Record<string, { label: string; href: string }[]> = {
  zh: [
    { label: 'RWA入门', href: '#rwa-entry' }, { label: '区块链基础', href: '#blockchain' },
    { label: '全球政策', href: '#policy' }, { label: '87个案例库', href: '#cases' },
    { label: '香港持牌机构', href: '#hk-institutions' }, { label: '国内区块链服务商', href: '#domestic' },
  ],
  en: [
    { label: 'RWA Basics', href: '#rwa-entry' }, { label: 'Blockchain', href: '#blockchain' },
    { label: 'Global Policy', href: '#policy' }, { label: '87 Cases', href: '#cases' },
    { label: 'HK Licensed', href: '#hk-institutions' }, { label: 'Domestic Providers', href: '#domestic' },
  ],
  fr: [
    { label: 'Bases RWA', href: '#rwa-entry' }, { label: 'Blockchain', href: '#blockchain' },
    { label: 'Politique Mondiale', href: '#policy' }, { label: '87 Cas', href: '#cases' },
    { label: 'Agréés HK', href: '#hk-institutions' }, { label: 'Prestataires', href: '#domestic' },
  ],
  es: [
    { label: 'Bases RWA', href: '#rwa-entry' }, { label: 'Blockchain', href: '#blockchain' },
    { label: 'Política Global', href: '#policy' }, { label: '87 Casos', href: '#cases' },
    { label: 'Licenciados HK', href: '#hk-institutions' }, { label: 'Proveedores', href: '#domestic' },
  ],
  pt: [
    { label: 'Bases RWA', href: '#rwa-entry' }, { label: 'Blockchain', href: '#blockchain' },
    { label: 'Política Global', href: '#policy' }, { label: '87 Casos', href: '#cases' },
    { label: 'Licenciados HK', href: '#hk-institutions' }, { label: 'Fornecedores', href: '#domestic' },
  ],
  ja: [
    { label: 'RWA基礎', href: '#rwa-entry' }, { label: 'ブロックチェーン', href: '#blockchain' },
    { label: 'グローバル政策', href: '#policy' }, { label: '87事例', href: '#cases' },
    { label: 'HK認可機関', href: '#hk-institutions' }, { label: '国内業者', href: '#domestic' },
  ],
  de: [
    { label: 'RWA Grundlagen', href: '#rwa-entry' }, { label: 'Blockchain', href: '#blockchain' },
    { label: 'Globale Politik', href: '#policy' }, { label: '87 Fälle', href: '#cases' },
    { label: 'HK Lizenziert', href: '#hk-institutions' }, { label: 'Anbieter', href: '#domestic' },
  ],
  ko: [
    { label: 'RWA 기초', href: '#rwa-entry' }, { label: '블록체인', href: '#blockchain' },
    { label: '글로벌 정책', href: '#policy' }, { label: '87 사례', href: '#cases' },
    { label: 'HK 인가기관', href: '#hk-institutions' }, { label: '국내 업체', href: '#domestic' },
  ],
  ar: [
    { label: 'أساسيات RWA', href: '#rwa-entry' }, { label: 'بلوكتشين', href: '#blockchain' },
    { label: 'السياسة العالمية', href: '#policy' }, { label: '87 حالة', href: '#cases' },
    { label: 'مرخصو HK', href: '#hk-institutions' }, { label: 'مزودون', href: '#domestic' },
  ],
  ru: [
    { label: 'Основы RWA', href: '#rwa-entry' }, { label: 'Блокчейн', href: '#blockchain' },
    { label: 'Глобальная Политика', href: '#policy' }, { label: '87 Случаев', href: '#cases' },
    { label: 'Лицензиаты HK', href: '#hk-institutions' }, { label: 'Провайдеры', href: '#domestic' },
  ],
};

const MORE_LINKS: Record<string, { label: string; href: string }[]> = {
  zh: [
    { label: '企业落地流程', href: '#landing' }, { label: '全行业上链指南', href: '#industry' },
    { label: '高校与教育', href: '#education' }, { label: '资讯与会议', href: '#news' },
    { label: '名词百科', href: '#glossary' }, { label: '关于我们', href: '#about' },
  ],
  en: [
    { label: 'Enterprise SOP', href: '#landing' }, { label: 'Industry Guide', href: '#industry' },
    { label: 'Education', href: '#education' }, { label: 'News & Events', href: '#news' },
    { label: 'Glossary', href: '#glossary' }, { label: 'About Us', href: '#about' },
  ],
  fr: [
    { label: 'SOP Entreprise', href: '#landing' }, { label: 'Guide Sectoriel', href: '#industry' },
    { label: 'Éducation', href: '#education' }, { label: 'Actualités', href: '#news' },
    { label: 'Glossaire', href: '#glossary' }, { label: 'À Propos', href: '#about' },
  ],
  es: [
    { label: 'SOP Empresarial', href: '#landing' }, { label: 'Guía Sectorial', href: '#industry' },
    { label: 'Educación', href: '#education' }, { label: 'Noticias', href: '#news' },
    { label: 'Glosario', href: '#glossary' }, { label: 'Acerca de', href: '#about' },
  ],
  pt: [
    { label: 'SOP Empresarial', href: '#landing' }, { label: 'Guia Setorial', href: '#industry' },
    { label: 'Educação', href: '#education' }, { label: 'Notícias', href: '#news' },
    { label: 'Glossário', href: '#glossary' }, { label: 'Sobre', href: '#about' },
  ],
  ja: [
    { label: '企業SOP', href: '#landing' }, { label: '業界ガイド', href: '#industry' },
    { label: '教育', href: '#education' }, { label: 'ニュース', href: '#news' },
    { label: '用語集', href: '#glossary' }, { label: '概要', href: '#about' },
  ],
  de: [
    { label: 'Unternehmens-SOP', href: '#landing' }, { label: 'Branchenführer', href: '#industry' },
    { label: 'Bildung', href: '#education' }, { label: 'Nachrichten', href: '#news' },
    { label: 'Glossar', href: '#glossary' }, { label: 'Über uns', href: '#about' },
  ],
  ko: [
    { label: '기업 SOP', href: '#landing' }, { label: '산업 가이드', href: '#industry' },
    { label: '교육', href: '#education' }, { label: '뉴스', href: '#news' },
    { label: '용어집', href: '#glossary' }, { label: '소개', href: '#about' },
  ],
  ar: [
    { label: 'SOP المؤسسي', href: '#landing' }, { label: 'دليل القطاع', href: '#industry' },
    { label: 'تعليم', href: '#education' }, { label: 'أخبار', href: '#news' },
    { label: 'مسرد', href: '#glossary' }, { label: 'حول', href: '#about' },
  ],
  ru: [
    { label: 'Корпоративный SOP', href: '#landing' }, { label: 'Отраслевой Гид', href: '#industry' },
    { label: 'Образование', href: '#education' }, { label: 'Новости', href: '#news' },
    { label: 'Глоссарий', href: '#glossary' }, { label: 'О нас', href: '#about' },
  ],
};

const officialLinks = [
  {
    category: '🇨🇳 内地官方',
    links: [
      { name: '中国证监会', url: 'http://www.csrc.gov.cn', desc: '资本市场监管' },
      { name: '国家互联网信息办公室', url: 'http://www.cac.gov.cn', desc: '区块链备案主管' },
      { name: '中国人民银行', url: 'http://www.pbc.gov.cn', desc: '金融货币监管' },
      { name: '国家发展改革委', url: 'http://www.ndrc.gov.cn', desc: '数字经济政策' },
    ],
  },
  {
    category: '🇭🇰 香港官方',
    links: [
      { name: 'SFC 证监会', url: 'https://www.sfc.hk', desc: '香港证券监管机构' },
      { name: 'HKMA 金管局', url: 'https://www.hkma.gov.hk', desc: 'Project Ensemble主管' },
      { name: 'HKEX 港交所', url: 'https://www.hkex.com.hk', desc: '数字证券结算' },
      { name: 'InvestHK 投资推广署', url: 'https://www.investhk.gov.hk', desc: '香港投资资讯' },
    ],
  },
  {
    category: '🌐 International',
    links: [
      { name: 'BIS', url: 'https://www.bis.org', desc: 'CBDC & Tokenization Research' },
      { name: 'IOSCO', url: 'https://www.iosco.org', desc: 'Global Securities Standards' },
      { name: 'MAS Singapore', url: 'https://www.mas.gov.sg', desc: 'Project Guardian' },
      { name: 'ESMA', url: 'https://www.esma.europa.eu', desc: 'MiCA Framework' },
    ],
  },
  {
    category: '🏛️ Licensed',
    links: [
      { name: 'HashKey Exchange', url: 'https://hashkey.com', desc: 'HK S-class VATP' },
      { name: 'OSL Exchange', url: 'https://osl.com', desc: 'HK S-class VATP' },
      { name: 'Securitize', url: 'https://securitize.io', desc: 'RWA Tokenization Platform' },
      { name: 'RWA.xyz', url: 'https://rwa.xyz', desc: 'RWA Market Data' },
    ],
  },
];

export default function Footer() {
  const { lang } = useLang();
  const quickLinks = QUICK_LINKS[lang] ?? QUICK_LINKS['en'];
  const moreLinks = MORE_LINKS[lang] ?? MORE_LINKS['en'];

  return (
    <footer style={{ background: 'linear-gradient(180deg, #0F0030 0%, #1A0050 100%)' }}>
      <div className="h-px bg-gradient-to-r from-transparent via-[#7C3AED]/60 to-transparent" />

      <div className="max-w-[1440px] mx-auto px-4 lg:px-8 pt-14 pb-10">

        {/* Contact Section */}
        <div className="mb-12 bg-white/4 border border-white/10 rounded-2xl p-6">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-1 h-5 bg-[#F59E0B] rounded-full" />
            <h3 className="text-white font-black text-base">{getL('contactTitle', lang)}</h3>
          </div>
          <div className="flex flex-col md:flex-row items-start gap-8">
            <div className="flex flex-col items-center gap-3">
              <div className="w-32 h-32 rounded-xl overflow-hidden bg-white p-1.5 shadow-lg">
                <img src="https://static.readdy.ai/image/263618122c0c25cf0393568467bcbb5e/c10996b2a623167522d37564a5ca121d.jpeg" alt="WeChat QR Code" className="w-full h-full object-contain rounded-lg" />
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-wechat-line text-green-400 text-base" />
                <span className="text-white/70 text-xs font-semibold">{getL('wechatScan', lang)}</span>
              </div>
            </div>

            <div className="flex-1 space-y-4">
              <p className="text-white/50 text-sm leading-relaxed">{getL('contactDesc', lang)}</p>
              <div className="space-y-3">
                <a href="tel:+8613810001256" className="flex items-center gap-3 group cursor-pointer">
                  <div className="w-8 h-8 rounded-lg bg-[#7C3AED]/20 border border-[#7C3AED]/30 flex items-center justify-center">
                    <i className="ri-phone-line text-[#A78BFA] text-sm" />
                  </div>
                  <div>
                    <div className="text-white/40 text-[10px] uppercase tracking-widest">{getL('phone', lang)}</div>
                    <div className="text-white/80 text-sm font-semibold group-hover:text-[#F59E0B] transition-colors">(+86) 138-1000-1256</div>
                  </div>
                </a>
                <a href="mailto:13810001256@126.com" className="flex items-center gap-3 group cursor-pointer">
                  <div className="w-8 h-8 rounded-lg bg-[#F59E0B]/20 border border-[#F59E0B]/30 flex items-center justify-center">
                    <i className="ri-mail-line text-[#F59E0B] text-sm" />
                  </div>
                  <div>
                    <div className="text-white/40 text-[10px] uppercase tracking-widest">{getL('email', lang)}</div>
                    <div className="text-white/80 text-sm font-semibold group-hover:text-[#F59E0B] transition-colors">13810001256@126.com</div>
                  </div>
                </a>
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 rounded-lg bg-green-500/20 border border-green-500/30 flex items-center justify-center">
                    <i className="ri-wechat-line text-green-400 text-sm" />
                  </div>
                  <div>
                    <div className="text-white/40 text-[10px] uppercase tracking-widest">{getL('wechat', lang)}</div>
                    <div className="text-white/80 text-sm font-semibold">{getL('wechatAdd', lang)}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="shrink-0">
              <a href="/bbs" className="flex flex-col items-center gap-3 w-36 p-4 rounded-xl border border-[#7C3AED]/30 bg-[#7C3AED]/10 hover:bg-[#7C3AED]/20 hover:border-[#7C3AED]/50 transition-all group cursor-pointer">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#7C3AED] to-[#F59E0B] flex items-center justify-center">
                  <i className="ri-discuss-line text-white text-xl" />
                </div>
                <div className="text-center">
                  <div className="text-white font-black text-sm">{getL('forumTitle', lang)}</div>
                  <div className="text-white/50 text-[10px] mt-0.5">{getL('forumDesc', lang)}</div>
                </div>
                <div className="text-[#F59E0B] text-xs font-bold group-hover:translate-x-1 transition-transform">{getL('forumEnter', lang)}</div>
              </a>
            </div>
          </div>
        </div>

        {/* Official Links */}
        <div className="mb-12">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-1 h-5 bg-[#F59E0B] rounded-full" />
            <h3 className="text-white font-black text-base">{getL('officialLinks', lang)}</h3>
            <span className="text-white/30 text-xs ml-1">{getL('officialDesc', lang)}</span>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {officialLinks.map((group) => (
              <div key={group.category} className="bg-white/4 border border-white/8 rounded-xl p-4 hover:border-white/15 transition-all">
                <div className="text-white/70 text-xs font-bold mb-3">{group.category}</div>
                <div className="space-y-2">
                  {group.links.map((link) => (
                    <a key={link.name} href={link.url} target="_blank" rel="nofollow noreferrer" className="flex items-center justify-between gap-2 group cursor-pointer">
                      <div>
                        <div className="text-white/75 text-xs font-medium group-hover:text-[#F59E0B] transition-colors">{link.name}</div>
                        <div className="text-white/30 text-[10px]">{link.desc}</div>
                      </div>
                      <i className="ri-external-link-line text-white/20 group-hover:text-[#F59E0B] transition-colors text-xs shrink-0"></i>
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Main footer grid */}
        <div className="grid lg:grid-cols-4 gap-10 mb-10 pt-8 border-t border-white/8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-11 h-11 rounded-xl flex items-center justify-center text-white font-black text-xl shadow-lg" style={{ background: 'linear-gradient(135deg, #7C3AED, #F59E0B)' }}>R</div>
              <div>
                <div className="font-black text-white text-xl tracking-tight">RWA<span className="text-[#F59E0B]">99</span><span className="text-white/40 text-sm font-normal">.cn</span></div>
                <div className="text-white/40 text-xs">2026 RWA · Compliance Portal</div>
              </div>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-sm mb-4">{getL('brandDesc', lang)}</p>
            <div className="inline-flex items-center gap-2 px-3 py-2 text-xs bg-[#EF4444]/10 border border-[#EF4444]/20 rounded-lg text-[#EF4444]">
              <i className="ri-error-warning-fill text-sm"></i>
              {getL('disclaimer', lang)}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-bold text-white/50 uppercase tracking-widest mb-4">{getL('coreContent', lang)}</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-white/45 hover:text-[#F59E0B] transition-colors cursor-pointer flex items-center gap-1.5 group">
                    <i className="ri-arrow-right-s-line text-white/20 group-hover:text-[#F59E0B] transition-colors text-xs"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold text-white/50 uppercase tracking-widest mb-4">{getL('moreResources', lang)}</h4>
            <ul className="space-y-2.5">
              {moreLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-white/45 hover:text-[#F59E0B] transition-colors cursor-pointer flex items-center gap-1.5 group">
                    <i className="ri-arrow-right-s-line text-white/20 group-hover:text-[#F59E0B] transition-colors text-xs"></i>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/8 pt-6 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-white/30">
          <div>{getL('bottomBar', lang)}</div>
          <div className="flex items-center gap-1">
            Powered by{' '}
            <a href="https://readdy.ai/?ref=logo" className="hover:text-white/50 transition-colors ml-1" rel="nofollow">Readdy.ai</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
